__webpack_require__.p = "/dev/921-create-structure-parser-that-generate-cells/";